import React from "react";
import { SnackbarContext } from "./context";
import { Options } from "./use-snackbar";

export const useSnackbar = (): { openSnackbar: (options: Options) => void } =>
  React.useContext(SnackbarContext);
